import React from 'react';
import { connect } from 'react-redux';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import List from 'components/List';

import Loader from 'components/layout/Loader';
import InvoicesList from 'components/layout/financial/InvoicesList';

class Invoices extends React.Component {
  render() {
    const {
      intl: { messages },
      show,
      close,
      urlData,
      list,
    } = this.props;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.salesDoc.invoices}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <List
            listName="clientInvoices"
            url="/api/invoices.json"
            urlData={urlData}
            list={list}
            sortOptions={['cdate,desc']}
          >
            <div class="panel panel-transparent">
              <div class="panel-body no-padding">
                {list.pending ? <Loader /> : <InvoicesList list={list.data.list} inModal />}
              </div>
            </div>
          </List>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.list.clientInvoices,
  };
};

export default injectIntl(connect(mapStateToProps)(Invoices));
